// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-preview-box {
  position: relative;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}
.image-preview-box img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.image-title {
  position: absolute;
  top: 12px;
  left: 12px;
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.45);
  padding: 6px 12px;
  border-radius: 6px;
  max-width: 80%;
}

.image-category {
  position: absolute;
  bottom: 12px;
  left: 12px;
  background: rgb(195, 155, 34);
  color: #fff;
  padding: 6px 14px;
  border-radius: 15px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 600;
}


.image-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 8px;
  z-index: 5;
}


.icon-btn {
  background:rgb(195, 155, 34);
  color: #fff;                
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.icon-btn:hover {
  background: rgba(0, 0, 0, 0.85);
  transform: scale(1.05);
}


.icon-btn.delete {
  background: rgba(211, 47, 47, 0.85);
}

.icon-btn.delete:hover {
  background: rgba(183, 28, 28, 0.95);
}


.image-preview-box img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

gallery-category-text {
  color: #555;
}

.gallery-title {
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}

.gallery-category{
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  color:rgb(195, 155, 34);
  font-size: 18px;
  font-weight: 600;
}

.gallery-category-text{
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  color:#000;
  font-size: 18px;
  font-weight: 600;
}

@media (max-width: 576px) {
  .image-title {
    font-size: 14px;
    padding: 4px 10px;
  }

  .image-category {
    font-size: 12px;
    padding: 4px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Gallery/Gallery.css"],"names":[],"mappings":"AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;;AAGA;EACE,4BAA4B;EAC5B,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;;AAGA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');\n.image-preview-box {\n  position: relative;\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.image-preview-box img {\n  width: 100%;\n  height: 280px;\n  object-fit: cover;\n}\n\n.image-title {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  color: #fff;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  background: rgba(0, 0, 0, 0.45);\n  padding: 6px 12px;\n  border-radius: 6px;\n  max-width: 80%;\n}\n\n.image-category {\n  position: absolute;\n  bottom: 12px;\n  left: 12px;\n  background: rgb(195, 155, 34);\n  color: #fff;\n  padding: 6px 14px;\n  border-radius: 15px;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n\n.image-actions {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  gap: 8px;\n  z-index: 5;\n}\n\n\n.icon-btn {\n  background:rgb(195, 155, 34);\n  color: #fff;                \n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.icon-btn:hover {\n  background: rgba(0, 0, 0, 0.85);\n  transform: scale(1.05);\n}\n\n\n.icon-btn.delete {\n  background: rgba(211, 47, 47, 0.85);\n}\n\n.icon-btn.delete:hover {\n  background: rgba(183, 28, 28, 0.95);\n}\n\n\n.image-preview-box img {\n  width: 100%;\n  height: 280px;\n  object-fit: cover;\n}\n\ngallery-category-text {\n  color: #555;\n}\n\n.gallery-title {\n  text-decoration: none;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 18px;\n  color: #000;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.gallery-category{\n  text-decoration: none;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 18px;\n  color:rgb(195, 155, 34);\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.gallery-category-text{\n  text-decoration: none;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 18px;\n  color:#000;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n@media (max-width: 576px) {\n  .image-title {\n    font-size: 14px;\n    padding: 4px 10px;\n  }\n\n  .image-category {\n    font-size: 12px;\n    padding: 4px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
